<template>
  <div id="app">
    <div
      id="preloader"
      :class="[`preloader-spinner-border ${isShowPreloader && 'show'}`]"
    >
      <loader-spinner v-if="isShowPreloader" />
    </div>

    <div id="page">
      <vue-perfect-scrollbar class="global-page-scrollbar">
        <div class="main-page-header">
          <div class="page-header-block">
            <div class="page-header-date-block">
              <p class="page-header-date">{{ getTodayDateString() }}</p>
              <!-- <h1 class="page-header-date-title">{{ currentCustomer.name }}</h1> -->
            </div>
            <div class="page-header-customer-block">
              <!-- <div class="page-header-customer-notification">
              <bell-icon class="notification-icon"/>
            </div> -->
              <img
                v-if="currentCustomer.img"
                :src="currentCustomer.img"
                alt=""
                class="page-header-customer-notification-image"
              />
              <div v-else class="page-header-customer-notification">
                <user-icon class="page-header-customer-icon" />
              </div>
            </div>
          </div>
        </div>

        <buttons-top-container
          v-if="isShowPage === 'home'"
          @on-create-new-operation="onCreateNewOperation"
        />
        <payments-list-block-vue
          v-if="isShowPage === 'home'"
          :usedStatusButton="usedStatusButton"
          :recentArray="recentArray"
          @set-is-open-delete-all="setIsOpenDeleteAll"
          @is-open-settings-block="isOpenSettingsModalBlock"
          @set-filter-operations-by-date="setFilterOperationsByDate"
          @on-change-used-button="onchangeUsedButton"
          @on-open-payment-info="onOpenPaymentInfo"
          @on-create-new-operation="onCreateNewOperation"
          @on-use-animation="onUseAnimation"
        />
        <analitycs-page
          v-if="isShowPage === 'analitycs'"
          :currentAnalyticDate="currentAnalyticDate"
          @let-filter-analytics="letFilterAnalytics"
          @on-open-filter-fixed-block="onOpenFilterFixedBlock"
        />
        <categories-page
          v-if="isShowPage === 'categories'"
          :isShowPage="isShowPage"
          :activeType="activeType"
          @set-edit-category="setEditCategory"
          @set-check-list-value-type="setCheckListValueType"
          @on-open-create-categories-page="onOpenCreateCategoriesPage"
        />

        <invite-friends-page
          v-if="isShowPage === 'gifts'"
          @is-open-invites-block="isOpenInvitesBlock"
        />

        <pay-info-page v-if="isShowPage === 'payment'" />
        <!-- <div v-if="isShowPage === 'test'">
        <div id="reader"></div>
       <p>Result:{{ decodedText }}</p>
      <button @click="onStartScan">Start Scan</button>
      </div> -->

        <!-- <button @click="onSendTgData">SEND DATA</button> -->
      </vue-perfect-scrollbar>
    </div>
    <menu-block
      :isUseDarkMode="isUseDarkMode"
      @on-backdrop-click="onBackdropClick"
      @on-open-change-color-block="onOpenChangeColorBlock"
      @change-theme="changeTheme"
      @on-use-animation="onUseAnimation"
      @on-change-used-button="onchangeUsedButton"
      @set-filter-operations-by-date="setFilterOperationsByDate"
    />

    <payments-info-page
      :isOpenPaymentInfo="isOpenPaymentInfo"
      :openedCustomer="openedCustomer"
      @is-change-edit-module="isChangeEditModule"
      @on-backdrop-click="onBackdropClick"
      @on-open-question-block="onOpenQuestionBlock"
    />

    <create-operations-block
      :isOpenCreatePaymentBlock="isOpenCreatePaymentBlock"
      :currentCustomer="currentCustomer"
      :isEdit="isEditModule"
      :editElement="openedCustomer"
      :customType="typeValue"
      :customCurrency="typeCurrency"
      :telegram="Telegram"
      @set-is-open-settings-category="setIsOpenSettingsCategory"
      @on-backdrop-click="onBackdropClick"
      @on-edit-operation="onEditOperation"
      @on-edit-draw-operations="onEditDrawOperations"
      @on-save-operation="onSaveOperation"
      @on-save-payment-info="onSavePaymentInfo"
      @on-open-question-block="onOpenQuestionBlock"
      @get-type-categories="getTypeCategories"
    />

    <create-categories-block
      :isOpenCreateCategoriesBlock="isOpenCreateCategoriesBlock"
      :activeType="activeType"
      :isEditCategories="isEditCategories"
      :editCategoriesObject="editCategoriesObject"
      @on-backdrop-click="onBackdropClick"
    />

    <create-block
      :isOpenSuccessBlock="isOpenSuccessCreateBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <success-invite-block
      :isOpenSuccessInviteBlock="isOpenSuccessInviteBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <edit-block
      :isOpenSuccessBlock="isOpenSuccessEditBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <delete-block
      :isOpenSuccessBlock="isOpenSuccessDeleteBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <color-picker-block
      :isOpenChangeColorBlock="isOpenChangeColorBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <question-delete
      :isOpenQuestionBlock="isOpenQuestionBlock"
      @on-backdrop-click="onBackdropClick"
      @set-delete-operation="setDeleteOperation"
    />

    <delete-all-block
      :isDeleteAllBlock="isDeleteAllBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <analitycs-info-block
      :isOpenAnalitycsInfo="isShowGlobalAnalitycsBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <share-to-friends-block
      :isShowInvitesBlock="isShowInvitesBlock"
      @on-invite-friend="onInviteFriend"
      @on-backdrop-click="onBackdropClick"
    />

    <need-to-pay-block
      :isShowTariffsBlock="isShowTariffsBlock"
      :tariffsBlockMessage="tariffsBlockMessage"
      @on-use-animation="onUseAnimation"
      @on-backdrop-click="onBackdropClick"
    />

    <settings-modal
      :isOpenSettingsBlock="isOpenSettingsBlock"
      @on-backdrop-click="onBackdropClick"
    />

    <category-settings-block
      :isOpenCategorySettingsBlock="isOpenSettingsCategoryBlock"
      @set-is-open-settings-category="setIsOpenSettingsCategory"
      @set-is-open-category-page="setIsOpenCategoryPage"
      @on-backdrop-click="onBackdropClick"
    />

    <fixed-bottom-filter-block
      :title="`${$t('analytics.period')}`"
      :list="dateFilterList"
      :isShowFilterBlock="isShowFilterBlock"
      @on-backdrop-click="onBackdropClick"
      @let-filter-analytics="letFilterAnalytics"
    />

    <bottom-menu-block
      :isShowPage="isShowPage"
      @on-use-animation="onUseAnimation"
      @on-open-menu="onOpenMenu"
    />
    <!-- <button @click="initLocationSettings">
      Full screen
    </button>
    <button @click="getLocations">
      Normal mode
    </button> -->
    <!-- <button @click="openLocationSettings">
      789789789789789789789778
    </button> -->
    <!-- {{ resultText }} -->
  </div>
</template>

<script>
import {
  // BellIcon,
  UserIcon,
} from "vue-feather-icons";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MenuBlock from "./resources/js/pages/MenuBlock.vue";
import PaymentsInfoPage from "./resources/js/pages/PaymentsInfoPage.vue";
import InviteFriendsPage from "./resources/js/pages/InviteFriendsPage.vue";
import BottomMenuBlock from "./resources/js/pages/BottomMenuBlock.vue";
import PaymentsListBlockVue from "./resources/js/pages/PaymentsListBlock.vue";
import ButtonsTopContainer from "./resources/js/pages/ButtonsTopContainer.vue";
import CreateOperationsBlock from "./resources/js/pages/CreateOperationsBlock.vue";
import QuestionDelete from "./resources/js/pages/QuestionDelete.vue";
import ShareToFriendsBlock from "./components/openedBlocs/ShareToFriendsBlock.vue";
import NeedToPayBlock from "./components/openedBlocs/NeedToPayBlock.vue";
import CreateBlock from "./components/successBlocks/CreateBlock.vue";
import EditBlock from "./components/successBlocks/EditBlock.vue";
import DeleteBlock from "./components/successBlocks/DeleteBlock.vue";
import SuccessInviteBlock from "./components/successBlocks/SuccessInviteBlock.vue";
import AnalitycsPage from "./resources/js/pages/AnalitycsPage.vue";
import AnalitycsInfoBlock from "./components/openedBlocs/AnalitycsInfoBlock.vue";
import ColorPickerBlock from "./components/openedBlocs/ColorPickerBlock.vue";
import CategoriesPage from "./resources/js/pages/CategoriesPage.vue";
import LoaderSpinner from "./components/LoaderSpinner.vue";
import CreateCategoriesBlock from "./resources/js/pages/CreateCategoriesBlock.vue";
import CategorySettingsBlock from "./components/openedBlocs/CategorySettingsBlock.vue";
import SettingsModal from "./components/successBlocks/SettingsModal.vue";
import FixedBottomFilterBlock from "./components/openedBlocs/FixedBottomFilterBlock.vue";
import PayInfoPage from "./resources/js/pages/PayInfoPage.vue";
import DeleteAllBlock from "./components/openedBlocs/DeleteAllBlock.vue";
import {
  onVibrate,
  setMakeDate,
  getMonthFirstAndLastDay,
} from "./helpers/utils";
import { Html5QrcodeScanner } from "html5-qrcode";
import langObject from "./libs/i18n/index";
import { mapMutations } from "vuex";

export default {
  name: "app",
  components: {
    MenuBlock,
    PayInfoPage,
    PaymentsInfoPage,
    BottomMenuBlock,
    NeedToPayBlock,
    PaymentsListBlockVue,
    ButtonsTopContainer,
    CreateOperationsBlock,
    CategorySettingsBlock,
    DeleteAllBlock,
    CreateBlock,
    EditBlock,
    DeleteBlock,
    SettingsModal,
    AnalitycsInfoBlock,
    ColorPickerBlock,
    CategoriesPage,
    LoaderSpinner,
    InviteFriendsPage,
    CreateCategoriesBlock,
    SuccessInviteBlock,
    ShareToFriendsBlock,
    FixedBottomFilterBlock,

    QuestionDelete,
    AnalitycsPage,
    VuePerfectScrollbar,

    // BellIcon,
    UserIcon,
  },

  data() {
    return {
      resultText: "",
      isShowPage: "home",
      isOpenPaymentInfo: false,
      isOpenCreatePaymentBlock: false,
      isOpenSuccessCreateBlock: false,
      isOpenSuccessEditBlock: false,
      isOpenSuccessInviteBlock: false,
      isOpenSuccessDeleteBlock: false,
      isOpenQuestionBlock: false,
      isOpenChangeColorBlock: false,
      isOpenCreateCategoriesBlock: false,
      isOpenSettingsCategoryBlock: false,
      isDeleteAllBlock: false,
      isShowTariffsBlock: false,
      isOpenSettingsBlock: false,
      isUseDarkMode: false,
      isShowFilterBlock: false,
      isShowInvitesBlock: false,
      openedCustomer: {
        id: null,
        category: { title: null },
        currency: { title: null },
        img: null,
        title: null,
        sum: null,
        type: { title: null },
      },
      usedStatusButton: 2,
      activeBottomTab: 1,
      recentArray: [],
      isEditModule: false,
      typeValue: null,
      typeCurrency: null,
      isEditCategories: false,
      editCategoriesObject: {},
      activeType: { id: 1, title: "Витрата", slug: "expense" },
      currentAnalyticDate: null,
      decodedText: "",
      tariffsBlockMessage: "",
      isShowPreloader: true,
      Telegram: window.Telegram.WebApp,
      platform_id:
        window.Telegram.WebApp.initDataUnsafe?.user?.id.toString() ||
        "6993557740",
      dateFilterList: [],
    };
  },

  async mounted() {
    console.log(this.Telegram);
    window.scrollTo(0, 0);
    this.setSendReqToActiveData();

    let buttons = document.querySelectorAll("button");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        onVibrate("click");
      });
    });
  },
  beforeMount() {
    if (this.Telegram.initData) {
      try {
        this.Telegram.ready();
        this.Telegram.expand();
        this.Telegram.requestFullscreen();
        // this.Telegram.setHeaderColor("#ffffff");
        const data = JSON.stringify({ allow_vertical_swipe: false });
        window.TelegramWebviewProxy?.postEvent(
          "web_app_setup_swipe_behavior",
          data
        );
      } catch (e) {
        console.log(e);
      }
    }
    const theme = document.cookie.match(/theme=(.+?)(;|$)/)?.[1];
    let page = document.querySelector("#page-body");
    if (theme === "dark") {
      this.isUseDarkMode = true;
      page.classList.replace(page.classList.item(0), "theme-dark");
    } else {
      this.isUseDarkMode = false;
      page.classList.replace(page.classList.item(0), "theme-light");
    }
  },
  methods: {
    ...mapMutations([
      "addNewOpeation",
      "setIsOpenMenuSideBar",
      "setCreateNewCategories",
      "deleteOperationById",
      "setIsOpenGlobalAnalitycsBlock",
      "setIsChangeDrawEditMode",
      "setEditIncomeCategories",
      "setEditCostCategories",
      "setEditOtherCategories",
      "setChangeGlibalNotification",
      "setMainCurrency",
      "saveLanguages",
      "saveCurrentLang",
    ]),
    changeTheme() {
      let page = document.querySelector("#page-body");
      this.isUseDarkMode = !this.isUseDarkMode;
      page.classList.toggle("theme-light");
      page.classList.toggle("theme-dark");
      let theme = "white";
      if (this.isUseDarkMode) {
        theme = "dark";
      }
      document.cookie = `theme=${theme};expires=${new Date(
        Date.now() + 31536000000
      ).toUTCString()}`;
    },
    saveMainCurrency(lng) {
      if (JSON.stringify(window.localStorage) === "{}") {
        langObject.locale = lng;
        this.saveCurrentLang(lng);
        return;
      }
      let page = document.querySelector("#page-body");
      let language = window.localStorage.getItem("mainLanguages");
      let notification = window.localStorage.getItem("notifications");
      let mainCurrency = window.localStorage.getItem("mainCurrency");
      let color = window.localStorage.getItem("color");
      if (color) {
        page.classList.replace(page.classList.item(1), color);
      }
      if (language) {
        langObject.locale = JSON.parse(language).value;
        this.saveLanguages(JSON.parse(language));
      } else {
        langObject.locale = lng;
        this.saveCurrentLang(lng);
      }
      if (mainCurrency) {
        this.setMainCurrency(JSON.parse(mainCurrency));
      } else {
        this.setMainCurrency({ id: 2, code_alfa: "USD" });
      }
      if (notification) {
        this.setChangeGlibalNotification(JSON.parse(notification));
      }
    },
    initLocationSettings() {
      try {
        this.Telegram.requestFullscreen();
      } catch (error) {
        this.resultText = error.message;
      }
      // try {
      //   const data = this.Telegram.LocationManager.init((ev) => {
      //     this.resultText = JSON.stringify(ev);
      //   });
      //   console.log(data);

      //   alert(JSON.stringify(data));
      // } catch (error) {
      //   this.resultText = error.message;
      // }
    },
    getLocations() {
      try {
        this.Telegram.exitFullscreen();
      } catch (error) {
        this.resultText = error.message;
      }
      // try {
      //   const data = this.Telegram.LocationManager.getLocation((ev) => {
      //     this.resultText = JSON.stringify(ev);
      //   });
      //   console.log(data);

      //   alert(JSON.stringify(data));
      // } catch (error) {
      //   this.resultText = error.message;
      // }
    },
    openLocationSettings() {
      try {
        const data = this.Telegram.LocationManager.openSettings();
        this.resultText = JSON.stringify(data);

        alert(JSON.stringify(data));
      } catch (error) {
        this.resultText = error.message;
      }
    },
    // onSendTgData() {
    //   let data = {
    //     test: 'test info'
    //   }
    //  window.Telegram.WebApp.sendData(JSON.stringify(data))
    // },
    // isSaveNewCategory(value, isEdit) {
    //   if (isEdit) {
    //     if (this.activeType.id === 1) {
    //       this.setEditIncomeCategories(value)
    //     } else if (this.activeType.id === 2) {
    //       this.setEditCostCategories(value)
    //     } else {
    //       this.setEditOtherCategories(value)
    //     }
    //     this.isEditCategories = false
    //     this.editCategoriesObject = {}
    //   } else {
    //     this.setCreateNewCategories(value)
    //   }
    // },
    isOpenSettingsModalBlock() {
      this.isOpenSettingsBlock = true;
    },
    isOpenInvitesBlock() {
      this.isShowInvitesBlock = true;
    },
    onScanSuccess(decodedText, decodedResult) {
      this.decodedText = decodedText;
      console.log(`Code matched = ${decodedText}`, decodedResult);
    },

    onScanFailure(error) {
      console.warn(`Code scan error = ${error}`);
    },

    onInviteFriend() {
      onVibrate("click");
      this.isShowInvitesBlock = false;
      setTimeout(() => {
        this.isOpenSuccessInviteBlock = true;
      }, 1500);
    },

    setFilterOperationsByDate(date) {
      console.log({ date });
      let value = {
        ...date,
        ...this.currentCustomer,
      };
      this.$store.dispatch("getOperations", value);
    },

    setIsOpenDeleteAll() {
      this.isDeleteAllBlock = true;
    },

    onStartScan() {
      let html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        { fps: 10, qrbox: { width: 250, height: 250 } },
        false
      );
      html5QrcodeScanner.render(this.onScanSuccess, this.onScanFailure);
    },

    trimNonNumericStart(inputString) {
      let match = inputString.match(/^\D/);

      if (match) {
        let nonNumericChar = match[0];
        let index = inputString.indexOf(nonNumericChar);
        return inputString.slice(index + 1);
      }
      return inputString;
    },

    setSendReqToActiveData() {
      let data = {
        platform_id: this.platform_id,
        init_data: this.Telegram.initData,
      };
      //dev
      // let data = {
      //   platform_id: this.platform_id,
      //   init_data:
      //     this.Telegram.initData ||
      //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2Zpbi5ib3RvLmt5aXYudWEvYXBpL3YxL2F1dGgiLCJpYXQiOjE3MzQzNTA3NTQsImV4cCI6MTczNDM1NDM1NCwibmJmIjoxNzM0MzUwNzU0LCJqdGkiOiJQUk5FZHdpUWNKTU9kY1Q1Iiwic3ViIjoiNzUiLCJwcnYiOiIxZDgwNjg2MTcxODRlNjc4OGJkMmQ4ZjhjNzkwMzc0Y2NjNjE0ZTdkIn0.BMVBqRnJ30e-t2ZXNVPhLYonMVwLUUeiwoOm5VBcris",
      // };
      // prod
      // let data = {
      //   platform_id: this.platform_id,
      //   init_data:
      //     this.Telegram.initData ||
      //     "query_id=AAHsONkgAwAAAOw42SBXcPnm&user=%7B%22id%22%3A6993557740%2C%22first_name%22%3A%22Maksym%22%2C%22last_name%22%3A%22Boto%22%2C%22username%22%3A%22maksym_boto%22%2C%22language_code%22%3A%22uk%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FLUiFf87ux_zMmLl91bBzmejN4kuPxoCt2gPqRglq-c7wAJJ_Bvat75mbH86dUZJw.svg%22%7D&auth_date=1733905973&signature=Wh5bi4G8ojnM-aEwL9qfCuPEbAfJ2ckl0Z338DmGMlg-774RzOS2XYfWqp_rinVxOwZMfAxmf-v4IkCDdiKdBQ&hash=894dbeaa4b4dace813ba0cebc06725dd3c28329a7334c4820fd8d37923f4401d",
      // };
      this.$store.dispatch("setAutorisation", JSON.stringify(data)).then(() => {
        this.$store.dispatch("getCurrency");
        this.$store
          .dispatch("getCurrentCustomer", this.platform_id)
          .then((result) => {
            let value = {
              ...result.data,
              ...setMakeDate({ id: 1, value: this.$t("homePage.today") }),
            };
            let data = {
              platform_id: this.platform_id,
              account_ids: [value.id],
              from: getMonthFirstAndLastDay().firstDay,
              to: getMonthFirstAndLastDay().lastDay,
              currency_id: this.getMainCurrency.id,
            };
            this.$store.dispatch("getCustomers");
            this.$store.dispatch("getOperations", value);
            this.$store.dispatch("getTypesOperations", value.id).then(() => {
              let isEditDraw =
                this.trimNonNumericStart(window.location.pathname) === "draw";
              if (isEditDraw) {
                this.$store.dispatch("getDrawOperations", data).then((val) => {
                  let expenseType = this.typeOperations.find(
                    (el) => el.slug === "expense"
                  );
                  this.getTypeCategories(expenseType.id);
                  if (val.length) {
                    this.isOpenCreatePaymentBlock = true;
                  }
                });
              }
            });
            // this.$store.dispatch('getCategories', data.account_id)
            this.isShowPreloader = false;

            this.saveMainCurrency(result.data.language);
            this.onSaveActualLanguageFilter();
            console.log({ result }, 1);
            this.isShowTariffsBlock =
              result.data.customers[0].operations_limit_expired;
            this.tariffsBlockMessage =
              result.data.customers[0].operations_limit_expired_message;
          });
      });
    },

    onSaveActualLanguageFilter() {
      this.dateFilterList = [
        { id: 1, value: this.$t("analytics.currentMounth"), date: null },
        { id: 2, value: this.$t("analytics.january"), date: 1 },
        { id: 3, value: this.$t("analytics.february"), date: 2 },
        { id: 4, value: this.$t("analytics.march"), date: 3 },
        { id: 5, value: this.$t("analytics.april"), date: 4 },
        { id: 6, value: this.$t("analytics.may"), date: 5 },
        { id: 7, value: this.$t("analytics.june"), date: 6 },
        { id: 8, value: this.$t("analytics.july"), date: 7 },
        { id: 9, value: this.$t("analytics.august"), date: 8 },
        { id: 10, value: this.$t("analytics.september"), date: 9 },
        { id: 11, value: this.$t("analytics.october"), date: 10 },
        { id: 12, value: this.$t("analytics.november"), date: 11 },
        { id: 13, value: this.$t("analytics.december"), date: 12 },
      ];
    },

    letFilterAnalytics(value, type_id) {
      let data = {
        platform_id: this.currentCustomer.platform_id,
        account_ids: [this.currentCustomer.id],
        from: getMonthFirstAndLastDay(value?.date).firstDay,
        to: getMonthFirstAndLastDay(value?.date).lastDay,
        currency_id: this.getMainCurrency.id,
        type_id: type_id,
      };
      if (value) {
        this.currentAnalyticDate = value;
      } else {
        this.currentAnalyticDate = {
          id: 1,
          value: this.$t("analytics.currentMounth"),
          date: null,
        };
      }
      this.$store.dispatch("getAnalytics", data);
    },

    onOpenChangeColorBlock() {
      this.onBackdropClick();
      this.isOpenChangeColorBlock = true;
    },
    setDeleteOperation() {
      this.deleteOperationById(this.openedCustomer.id);
      this.$store.dispatch("deleteOperation", this.openedCustomer.id);
      this.onBackdropClick();
      setTimeout(() => {
        this.isOpenSuccessDeleteBlock = true;
        onVibrate("error");
      }, 500);
    },
    onCreateNewOperation(val) {
      onVibrate("click");
      if (val === "create" && !this.getOperations.length) {
        this.typeValue = "expense";
        this.isOpenCreatePaymentBlock = true;
        return;
      }
      if (val === "income") {
        this.typeValue = "income";
      }
      if (val === "cost") {
        this.typeValue = "expense";
      }
      if (val === "create") {
        let lastType = this.getOperations[0]?.type?.slug;
        this.typeValue = lastType;
      }
      this.isOpenCreatePaymentBlock = true;
    },
    isChangeEditModule(value) {
      this.isEditModule = value;
      if (value) {
        this.onCreateNewOperation();
      }
    },
    changeEditModule(value) {
      this.isEditModule = value;
    },
    onchangeUsedButton(id) {
      onVibrate("click");
      this.usedStatusButton = id;
    },
    onOpenMenu() {
      this.onUseAnimation(6);
      this.setIsOpenMenuSideBar(true);
    },
    onOpenPaymentInfo(value) {
      onVibrate("click");
      this.openedCustomer = value;
      this.isOpenPaymentInfo = true;
    },
    onSavePaymentInfo(value) {
      this.openedCustomer = value;
    },
    setIsOpenSettingsCategory() {
      this.isOpenSettingsCategoryBlock = !this.isOpenSettingsCategoryBlock;
    },
    setIsOpenCategoryPage() {
      this.onBackdropClick();
      this.onUseAnimation(1);
    },
    onOpenQuestionBlock() {
      this.onBackdropClick();
      this.isOpenQuestionBlock = true;
    },
    onOpenCreateCategoriesPage() {
      this.isOpenCreateCategoriesBlock = true;
    },
    onOpenFilterFixedBlock() {
      this.isShowFilterBlock = true;
    },
    getTypeCategories(id) {
      let data = {
        account_ids: [this.currentCustomer.id],
        type_id: id,
      };
      this.$store.dispatch("getCategories", data);
    },
    onBackdropClick() {
      onVibrate("click");
      if (this.isOpenMenuSideBar) {
        this.setIsOpenMenuSideBar(false);
      }
      if (this.isOpenPaymentInfo) {
        this.isOpenPaymentInfo = false;
      }
      if (this.isOpenCreatePaymentBlock) {
        this.isOpenCreatePaymentBlock = false;
        this.isEditModule = false;
        this.typeValue = null;
        this.typeCurrency = null;
        this.setIsChangeDrawEditMode(false);
      }
      if (this.isOpenSuccessCreateBlock) {
        this.isOpenSuccessCreateBlock = false;
      }
      if (this.isOpenSuccessDeleteBlock) {
        this.isOpenSuccessDeleteBlock = false;
      }
      if (this.isOpenSuccessEditBlock) {
        this.isOpenSuccessEditBlock = false;
        this.isEditModule = false;
      }
      if (this.isOpenQuestionBlock) {
        this.isOpenQuestionBlock = false;
      }
      if (this.isOpenCreateCategoriesBlock) {
        this.isOpenCreateCategoriesBlock = false;
        this.isEditCategories = false;
        this.editCategoriesObject = {};
      }
      if (this.isShowGlobalAnalitycsBlock) {
        this.setIsOpenGlobalAnalitycsBlock(false);
      }
      if (this.isOpenChangeColorBlock) {
        this.isOpenChangeColorBlock = false;
      }
      if (this.isShowInvitesBlock) {
        this.isShowInvitesBlock = false;
      }
      if (this.isOpenSuccessInviteBlock) {
        this.isOpenSuccessInviteBlock = false;
      }
      if (this.isOpenSettingsCategoryBlock) {
        this.isOpenSettingsCategoryBlock = false;
      }
      if (this.isOpenSettingsBlock) {
        this.isOpenSettingsBlock = false;
      }
      if (this.isShowFilterBlock) {
        this.isShowFilterBlock = false;
      }
      if (this.isDeleteAllBlock) {
        this.isDeleteAllBlock = false;
      }
      if (this.isShowTariffsBlock) {
        this.isShowTariffsBlock = false;
      }
    },
    onEditDrawOperations(id, data, isLast) {
      let dataInfo = {
        id: id,
        data: JSON.stringify(data),
      };
      this.$store.dispatch("editOperation", dataInfo);
      if (isLast) {
        this.onBackdropClick();
        setTimeout(() => {
          this.isOpenSuccessEditBlock = true;
          onVibrate("success");
        }, 500);
      }
    },
    onEditOperation(id, data) {
      this.onBackdropClick();
      let dataInfo = {
        id: id,
        data: JSON.stringify(data),
      };
      this.$store.dispatch("editOperation", dataInfo);
      setTimeout(() => {
        this.isOpenSuccessEditBlock = true;
        onVibrate("success");
      }, 500);
    },
    onSaveOperation(data) {
      this.onBackdropClick();
      this.$store.dispatch("createOperation", JSON.stringify(data));
      setTimeout(() => {
        this.isOpenSuccessCreateBlock = true;
        onVibrate("success");
      }, 500);
    },
    getTodayDateString() {
      const today = new Date();
      const options = {
        weekday: "long",
        day: "numeric",
        month: "long",
      };

      let lang = "en-US";
      if (this.getCurrentLang.value === "uk") {
        lang = "uk-UA";
      } else if (this.getCurrentLang.value === "ru") {
        lang = "ru-RU";
      } else if (this.getCurrentLang.value === "es") {
        lang = "es-ES";
      }
      return today.toLocaleDateString(lang, options);
      // return today.toLocaleDateString("en-US", options);
    },
    setCheckListValueType(value) {
      this.activeType = value;
      let expenseType = this.typeOperations.find(
        (el) => el.slug === value.slug
      );
      this.getTypeCategories(expenseType.id);
    },
    setEditCategory(value) {
      this.isEditCategories = true;
      this.editCategoriesObject = value;
      this.isOpenCreateCategoriesBlock = true;
      let currType = this.typeOperations.find(
        (el) => el.slug === this.activeType.slug
      );
      this.getTypeCategories(currType.id);
    },
    onUseAnimation(id) {
      let footer = document.querySelector("#footer-bar");
      footer.classList.add(`active${id}`);
      // let TgVibro = this.Telegram.HapticFeedback
      setTimeout(() => {
        footer.classList.remove(`active${id}`);
      }, 500);
      if (id !== "categories") {
        this.activeType = { id: 1, title: "Витрата", slug: "expense" };
      }
      let expenseType;
      if (id === 2 || id === 1) {
        expenseType = this.typeOperations.find((el) => el.slug === "expense");
      }
      switch (id) {
        case 1:
          // TgVibro.impactOccurred()
          this.getTypeCategories(expenseType.id);
          this.isShowPage = "categories";
          break;
        case 2:
          this.letFilterAnalytics(null, expenseType.id);
          this.isShowPage = "analitycs";
          break;
        case 3:
          // TgVibro.notificationOccurred()
          this.isShowPage = "home";
          break;
        case 4:
          // TgVibro.selectionChanged()
          this.isShowPage = "gifts";
          break;
        case 5:
          this.isShowPage = "payment";
          break;
        default:
          // this.isShowPage = 'home'
          return;
      }
    },
  },
  computed: {
    getCustomers() {
      return this.$store.getters.getCustomers;
    },
    getOperations() {
      return this.$store.getters.getOperations;
    },
    currentCustomer() {
      return this.$store.getters.currentCustomer;
    },
    typeOperations() {
      return this.$store.getters.typeOperations;
    },
    operationsCategories() {
      return this.$store.getters.operationsCategories;
    },
    isShowGlobalAnalitycsBlock() {
      return this.$store.getters.isShowGlobalAnalitycsBlock;
    },
    isOpenMenuSideBar() {
      return this.$store.getters.isOpenMenuSideBar;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getMainCurrency() {
      return this.$store.getters.getMainCurrency;
    },
    getCurrentLang() {
      return this.$store.getters.getCurrentLang;
    },
  },
  watch: {
    // getCustomers(newVal, oldVal) {
    //   this.$store.dispatch('getCurrentCustomer', newVal[0].id).then((value) => {
    //     this.$store.dispatch('getOperations', value.id)
    //   })
    //   let val = oldVal
    //   val
    // },
    getOperations(newVal, oldVal) {
      this.recentArray = newVal;
      let val = oldVal;
      val;
    },
  },
};
</script>

<style scoped>
@import "./styles/main.css";
@import "./styles/darkMode.css";

.backdrop {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0);
  /* opacity: 0; */
  z-index: -1;
  transition: all 0.5s ease;
}

.show-backdrop {
  background-color: rgba(0, 0, 0, 0.37);
  /* opacity: 1; */
  z-index: 1000;
}

.payment-info-block {
  position: absolute;
  width: 95%;
  left: 2.5%;
  bottom: 2.5%;
  padding: 15px;
  padding-top: 80px;
  transform: translateY(110%);
  pointer-events: all !important;
  -webkit-backdrop-filter: saturate(180%) blur(80px);
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 1001 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.5s ease;
}

.open-payment-info-block {
  transform: none;
}

.info-plist-price {
  color: #4a89dc;
}

.main-page-header {
  padding-top: 100px;
}

.page-header-block {
  position: relative;
  z-index: 90;
  padding: 5px 15px 10px 15px;
  display: flex;
}

.page-header-date-block {
  margin-right: auto;
  align-self: center;
}

.page-header-customer-block {
  margin-left: auto;
  align-self: center;
  display: flex;
}

.page-header-date {
  margin-bottom: -6px;
  font-size: 13px;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  color: #4a89dc;
}

.page-header-date-title {
  font-size: 28px;
  margin-bottom: -3px;
  line-height: 30px;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  margin-bottom: 5px;
  letter-spacing: -0.6px;
}

.theme-dark .page-header-date-title {
  color: #fff;
}

.page-header-customer-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 12px;
  width: 45px;
  height: 45px;
  transition: all 120ms ease;
  border-radius: 20px !important;
  border: none;
  background-image: var(--main-bg-color);
  position: relative;
  z-index: 10;
  overflow: visible !important;
  cursor: pointer;
}

.page-header-customer-notification::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}

.page-header-customer-notification-image {
  position: relative;
  width: 45px;
  height: 45px;
  margin-left: 12px;
  border-radius: 20px;
  cursor: pointer;
}

.page-header-customer-icon {
  color: #fff;
}

.notification-icon {
  color: #fff;
  fill: #fff;
}

.notification-block {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #d84558;
  color: #fff;
}

.global-page-scrollbar {
  max-height: 90vh;
  width: 100%;
}

.vue-scanner-block {
  height: 70vh;
}

.preloader-spinner-border {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0);
  z-index: -1;
  transition: all 0.5s ease;
}

.preloader-spinner-border.show {
  background: rgba(255, 255, 255, 1);
  z-index: 99999;
}

.footer-bar.active1 {
  transform: rotateX(25deg) rotateY(-3deg);
}
.footer-bar.active2 {
  transform: rotateX(15deg) rotateY(-3deg);
}
.footer-bar.active3 {
  transform: rotateX(30deg);
}
.footer-bar.active4 {
  transform: rotateX(15deg) rotateY(3deg);
}
.footer-bar.active5 {
  transform: rotateX(25deg) rotateY(3deg);
}
</style>
